import { LocationOptionData } from '@shared/interfaces/LocationOptionData';

export const sortLocationOptions = (locations: LocationOptionData[]): LocationOptionData[] => {
  return [...locations].sort(
    (
      { name: country1, locationArea: locationArea1, isLocationArea: isArea1 },
      { name: country2, locationArea: locationArea2, isLocationArea: isArea2 }
    ) =>
      locationArea1 === locationArea2
        ? isArea1 === isArea2
          ? country1 > country2
            ? 1
            : -1
          : isArea1 > isArea2
          ? -1
          : 1
        : locationArea1 > locationArea2
        ? 1
        : -1
  );
};
